import { useMainButton, useTma, type MainButtonParams } from '@/app/TmaProvider';

import { Button } from './Button';

/**
 * Основное действие экрана через нативную MainButton Telegram.
 * Вне Telegram (dev-mock) рендерит обычную кнопку внизу, чтобы сценарий был проходим в браузере.
 */
export function MainButton(params: MainButtonParams) {
  const { mocked } = useTma();
  useMainButton(params);

  if (!mocked || params.visible === false) return null;
  return (
    <>
      {/* Кнопка вне Telegram рисуется поверх страницы, и последний блок экрана уходил под неё
          («Не нашёл своё? Предложить активность» на шаге активностей). Распорка в потоке
          освобождает ровно её высоту. */}
      <div aria-hidden="true" className="h-28" />
      <div
        className="chrome-bottom fixed inset-x-0 bottom-0 z-40 px-4 pt-3"
        style={{ paddingBottom: 'calc(var(--safe-bottom) + 1rem)' }}
      >
        <Button
          size="lg"
          fullWidth
          onClick={params.onClick}
          disabled={params.enabled === false}
          loading={params.loading}
        >
          {params.text}
        </Button>
      </div>
    </>
  );
}
